import { type EducationState } from "./state";

export const initialState: EducationState = {
  topics: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isCompleting: false,
  isCompleted: false,
  completeError: "",
};
